import { downloadName, normalizedFileBlob } from './fileNames';
import { API_URL } from '../api';
import { getAuthToken } from '../auth';

export function resolveFileUrl(file) {
  // Storage IDs are UUIDs. Never send them to the legacy integer Bitrix proxy.
  if (file.link || file.content_url || file.url) return file.link || file.content_url || file.url;
  if (/^\d+$/.test(String(file.id || ''))) return `${API_URL}/main/api/files/proxy/${file.id}/`;
  if (file.id && /^[a-f\d-]{36}$/i.test(String(file.id))) return `${API_URL}/api/storage/nodes/${file.id}/content/`;
  return file.download_url || '';
}
export function parsedFileUrl(value) {
  const url = new URL(value, API_URL + '/');
  if (!['https:', 'http:'].includes(url.protocol) || url.username || url.password) throw new Error('Недопустимая ссылка на файл');
  return url;
}
export function isProtectedApi(value) {
  const url = parsedFileUrl(value);
  return url.origin === new URL(API_URL).origin;
}
export async function authenticatedFileRequest(value) {
  const url = parsedFileUrl(value);
  if (!isProtectedApi(url.href)) throw new Error('Внешняя ссылка открывается отдельно');
  const token = getAuthToken();
  if (!token) throw new Error('Сессия закончилась. Войдите в кабинет заново.');
  let response;
  try {
    response = await fetch(url.href, { headers: { Authorization: `Bearer ${token}` },
      credentials: 'omit', redirect: 'error', referrerPolicy: 'no-referrer' });
  } catch (_) { throw new Error('Не удалось загрузить файл. Проверьте соединение и повторите.'); }
  if (!response.ok) {
    let data; try { data = await response.json(); } catch (_) { data = null; }
    throw new Error(response.status === 401 ? 'Сессия закончилась. Войдите в кабинет заново.'
      : response.status === 403 ? 'Нет доступа к этим материалам. Обратитесь к менеджеру.'
      : data?.detail || data?.message || `Не удалось загрузить материалы (${response.status})`);
  }
  return response;
}

export async function openEventFile(file, download = false) {
  const value = resolveFileUrl(file);
  if (!value) throw new Error('Для файла не найдена ссылка');
  const url = parsedFileUrl(value);
  if (!isProtectedApi(url.href)) {
    window.open(url.href, '_blank', 'noopener,noreferrer');
    return;
  }
  // Open synchronously on the tap: iOS blocks tabs opened after an awaited request.
  const tab = !download ? window.open('about:blank', '_blank') : null;
  if (!download && !tab) throw new Error('Разрешите открытие новой вкладки или нажмите «Скачать».');
  if (tab) { tab.opener = null; tab.document.title = 'Загрузка файла…'; }
  try {
    const response = await authenticatedFileRequest(url.href);
    const blob = await normalizedFileBlob(await response.blob(), file);
    const type = blob.type.toLowerCase();
    if (type.includes('application/json') || type.includes('text/html') || type.includes('svg') || type.includes('javascript')) {
      throw new Error('Сервер вернул страницу или данные вместо файла. Обновите карточку и повторите.');
    }
    const objectUrl = URL.createObjectURL(blob);
    const filename = downloadName(file, type, response.headers.get('Content-Disposition') || '');
    const inline = type === 'application/pdf' || /^image\/(jpeg|png|gif|webp|avif|bmp)$/.test(type);
    if (download || !inline) {
      const a = document.createElement('a'); a.href = objectUrl; a.download = filename;
      document.body.appendChild(a); a.click(); a.remove();
      if (tab) tab.close();
    } else {
      // Обёртка сохраняет понятное имя при скачивании защищённого blob-файла.
      tab.document.title = filename;
      tab.document.body.style.cssText = 'margin:0;background:#f5f6fa;font:16px system-ui;display:flex;flex-direction:column;height:100vh';
      const link = tab.document.createElement('a');
      link.href = objectUrl; link.download = filename; link.textContent = `Скачать ${filename}`;
      link.style.cssText = 'padding:16px;color:#572ac3;background:white;overflow-wrap:anywhere';
      tab.document.body.appendChild(link);
      const preview = tab.document.createElement(type.startsWith('image/') ? 'img' : 'iframe');
      preview.src = objectUrl;
      if (type.startsWith('image/')) preview.alt = filename;
      else preview.title = filename;
      preview.style.cssText = 'flex:1;min-height:0;width:100%;object-fit:contain;border:0';
      tab.document.body.appendChild(preview);
    }
    // Allow a mobile browser enough time to load the document.
    setTimeout(() => URL.revokeObjectURL(objectUrl), 10 * 60 * 1000);
  } catch (error) { if (tab) tab.close(); throw error; }
}
